import { createContext, useContext, useReducer } from 'react';

const AppContext = createContext();

const initialState = {
  // User & account
  user: null,
  salesArea: null,
  salesEntity: null,
  customerAccount: null,
  // Preferences
  uom: 'metric', // 'metric' | 'imperial'
  language: 'en',
  // UI state
  drawerOpen: false,
  isLoading: false,
  error: null,
};

function reducer(state, action) {
  switch (action.type) {
    case 'SET_USER': return { ...state, user: action.payload };
    case 'SET_SALES_AREA': return { ...state, salesArea: action.payload };
    case 'SET_SALES_ENTITY': return { ...state, salesEntity: action.payload };
    case 'SET_CUSTOMER_ACCOUNT': return { ...state, customerAccount: action.payload };
    case 'SET_UOM': return { ...state, uom: action.payload };
    case 'SET_LANGUAGE': return { ...state, language: action.payload };
    case 'TOGGLE_DRAWER': return { ...state, drawerOpen: !state.drawerOpen };
    case 'SET_LOADING': return { ...state, isLoading: action.payload };
    case 'SET_ERROR': return { ...state, error: action.payload };
    case 'RESET': return initialState;
    default: return state;
  }
}

export const AppProvider = ({ children }) => {
  const [state, dispatch] = useReducer(reducer, initialState);
  return <AppContext.Provider value={{ state, dispatch }}>{children}</AppContext.Provider>;
};

export const useApp = () => useContext(AppContext);
export default AppContext;
